"use strict";
"use client";
import { useContext } from "react";
import { ComponentsContext, defaultComponents } from "./ComponentsContext.js";
const useComponents = () => {
  const components = useContext(ComponentsContext) || {};
  return { ...defaultComponents, ...components };
};
export {
  useComponents
};
